import { DeviceInfo, DevicePlugin } from '@jarvis/jweb-core'
import { Logger } from '../../utils/helperMethods'

export class DeviceSupplier {
  public static create = async (
    devicePlugin: DevicePlugin
  ): Promise<DeviceSupplier> => {
    //
    Logger.log('DeviceProvider.create method called')

    const deviceSupplier: DeviceSupplier = new DeviceSupplier(devicePlugin)

    try {
      deviceSupplier.setDeviceInfo(await devicePlugin.getInfo())
    } catch (error) {
      const message = `DeviceSupplier.creator method failed with:
          Object: DevicePlugin.getInfo()
          ErrorType: Error
          Reason: Error getting device info: ${error}`
      Logger.strError(message)
      throw Error(message)
    }

    return deviceSupplier
  }

  public getDeviceInfo = (): DeviceInfo => {
    //
    return this.deviceInfo
  }

  private constructor(devicePlugin: DevicePlugin) {
    //
    if (Object.keys(devicePlugin).length === 0) {
      const message = `DeviceSupplier.constructor method failed with:
          Object: DevicePlugin
          ErrorType: Not Available
          Reason: JWeb plugins not available`
      Logger.strError(message)
      throw Error(message)
    }
    this.devicePlugin = devicePlugin
  }

  private setDeviceInfo = (deviceInfo: DeviceInfo) => {
    this.deviceInfo = deviceInfo
  }

  private devicePlugin: DevicePlugin
  private deviceInfo: DeviceInfo
}
